module.exports = fox._r("images/avatar.gif", __webpack_public_path__ + "images/avatar.gif");


//////////////////
// WEBPACK FOOTER
// ./images/avatar.gif
// module id = 979
// module chunks = 4